export const GET_COMBO_NGUON_KHACH_HANG = "GET_COMBO_NGUON_KHACH_HANG";
export const GET_COMBO_NGUON_KHACH_HANG_SUCCESS =
  "GET_COMBO_NGUON_KHACH_HANG_SUCCESS";
export const GET_COMBO_NGUON_KHACH_HANG_FAILURE =
  "GET_COMBO_NGUON_KHACH_HANG_FAILURE";
